$(function () {
  $('.awmainslider').slick({
    arrows: true,
    dots: false,
    speed: 600,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        },
      },
    ],
  });
  $('.awslider').slick({
    arrows: true,
    dots: false,
    speed: 600,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
    ],
  });
});